import React from 'react';
import { Card, CardContent } from './ui/card';
import StandardRide from '../assets/StandardRide.svg';
import WomenRide from '../assets/WomenRide.svg';
import GroupRide from '../assets/GroupRide.svg';
import checkIcon from "../assets/CheckIcon.svg";

import './ServicesSection.css';

const ServicesSection = () => {
  const services = [
    {
      title: 'Standard Rides',
      description:
        'Fast, reliable rides anywhere in the Greater Toronto Area. Available 24/7 for everyday transportation needs.',
      image: StandardRide,
      features: [
        'Available 24/7 across GTA',
        'Capacity: 1-4 passengers',
        'Comfortable sedans and compact SUVs',
        'Real-time GPS tracking',
        'Upfront pricing with no hidden fees',
        'In-app payment',
        'Professional vetted drivers'
      ]
    },
    {
      title: 'Women-for-Women Rides',
      description:
        'Safe rides by women, for women. Request female drivers for enhanced safety and comfort.',
      image: WomenRide,
      features: [
        'Female drivers only',
        'Enhanced safety training',
        'Priority emergency support',
        'Community support network',
        'Same-day availability',
        'All standard ride features included'
      ]
    },
    {
      title: 'Group Rides',
      description: 'Travel together with larger vehicles for groups of 5-7 passengers.',
      image: GroupRide,
      features: [
        'SUVs and minivans',
        'Extra luggage capacity',
        'Child seat availability',
        'Group payment splitting',
        'Corporate accounts available',
        'Perfect for family outings and airport runs'
      ]
    }
  ];

  return (
    <section id="services" className="services-section  pt-4 mb-28">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">Choose the ride that perfectly fits your needs</p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <Card key={index} className="service-card">
              {/* image */}
              <div className="service-image-wrapper">
                <img src={service.image} alt={service.title} className="service-image" />
              </div>

              {/* compact content shown initially (title + short desc) */}
              <CardContent className="service-content compact">
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
              </CardContent>

              {/* FULL PANEL: covers whole card on hover and contains title+desc+features */}
              <div className="service-full-panel" aria-hidden="true">
                <div className="full-panel-inner">
                  <h3 className="panel-title">{service.title}</h3>
                  <p className="panel-description">{service.description}</p>

                  <h4 className="panel-features-title">Features</h4>
                  <ul className="panel-features-list">
                    {service.features && service.features.map((f, i) => (
                      <li key={i} className="panel-feature-item">
                        <img src={checkIcon} alt="" className="feature-check-icon" />
                        <span>{f}</span>
                      </li>

                    ))}
                  </ul>
                </div>
              </div>
            </Card>

          ))}

        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
